
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
// import axios from "axios";
// import { useAuth } from '../../context/auth';
// import { useNavigate } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { FiRefreshCcw, FiDownload, FiMaximize2, FiMinimize2 } from 'react-icons/fi';
// import '../cssStyle/SimpleBarChart.css';

// const SimpleBarChart = () => {
//   const [chartData, setChartData] = useState([]);
//   const [allData, setAllData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [totalSignals, setTotalSignals] = useState(0);
//   const [topCount, setTopCount] = useState(60);
//   const [sortBy, setSortBy] = useState("signals");
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [lastUpdated, setLastUpdated] = useState(null);
//   const [currentTime, setCurrentTime] = useState(new Date());
  
//   // Refs
//   const topCountRef = useRef(30); 
//   const sortByRef = useRef("signals");
//   const allDataRef = useRef([]);
//   const totalSignalsRef = useRef(0);
//   const chartContainerRef = useRef(null);
//   const intervalRef = useRef(null);
//   const clockIntervalRef = useRef(null);
//   const isMountedRef = useRef(true);
  
//   const { getAdminAuthToken } = useAuth();
//   const navigate = useNavigate();
//   const token = getAdminAuthToken();

//   // Update refs
//   useEffect(() => {
//     topCountRef.current = topCount;
//   }, [topCount]);

//   useEffect(() => {
//     sortByRef.current = sortBy;
//   }, [sortBy]);

//   useEffect(() => {
//     allDataRef.current = allData;
//   }, [allData]);

//   useEffect(() => {
//     totalSignalsRef.current = totalSignals;
//   }, [totalSignals]);

//   // Real-time clock
//   useEffect(() => {
//     clockIntervalRef.current = setInterval(() => {
//       if (isMountedRef.current) {
//         setCurrentTime(new Date());
//       }
//     }, 1000);
    
//     return () => {
//       if (clockIntervalRef.current) {
//         clearInterval(clockIntervalRef.current);
//       }
//     };
//   }, []);

//   const updateChartDataWithCurrentSettings = useCallback(() => {
//     const currentAllData = allDataRef.current;
//     const currentTopCount = topCountRef.current;
//     const currentSortBy = sortByRef.current;
//     const currentTotalSignals = totalSignalsRef.current;
    
//     if (!currentAllData || currentAllData.length === 0) return;
    
//     // ✅ Filter out symbols with only 1 signal
//     let filteredData = currentAllData.filter(item => item.signals > 1);
    
//     if (filteredData.length === 0) {
//       setChartData([]);
//       return;
//     }
    
//     let sortedData = [...filteredData];
    
//     if (currentSortBy === "signals") {
//       sortedData.sort((a, b) => b.signals - a.signals);
//     } else if (currentSortBy === "name") {
//       sortedData.sort((a, b) => a.name.localeCompare(b.name));
//     } else if (currentSortBy === "dr") {
//       sortedData.sort((a, b) => b.drCount - a.drCount);
//     } else if (currentSortBy === "ur") {
//       sortedData.sort((a, b) => b.urCount - a.urCount);
//     }
    
//     const topData = sortedData.slice(0, currentTopCount);
//     const maxSignals = topData[0]?.signals || 1;
    
//     const finalData = topData.map(item => ({
//       ...item,
//       percentage: ((item.signals / currentTotalSignals) * 100).toFixed(1),
//       barWidthPercentage: (item.signals / maxSignals) * 100
//     }));
    
//     if (isMountedRef.current) {
//       setChartData(finalData);
//     }
//   }, []);

//   const fetchDataSilent = useCallback(async () => {
//     if (!token || !isMountedRef.current) return;

//     try {
//       const response = await axios.get(
//         "https://api.algocontroller.com/admin_app/getting_admin_analysis",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       const rawData = response.data?.data || [];
      
//       const filteredData = [];
//       rawData.forEach(insItem => {
//         if (insItem.data && Array.isArray(insItem.data)) {
//           const filteredTypesData = insItem.data.filter(item => 
//             item.type === 'second' || item.type === 'third'
//           );
//           if (filteredTypesData.length > 0) {
//             filteredData.push({
//               ...insItem,
//               data: filteredTypesData
//             });
//           }
//         }
//       });
      
//       const symbolMap = new Map();
      
//       filteredData.forEach(insItem => {
//         if (insItem.data && Array.isArray(insItem.data)) {
//           insItem.data.forEach(item => {
//             const percentageValue = parseFloat(item.percentage);
//             if (percentageValue === 0) return;
            
//             const symbol = item.symbol;
//             const category = item.cat;
            
//             if (!symbolMap.has(symbol)) {
//               symbolMap.set(symbol, {
//                 symbol: symbol,
//                 count: 0,
//                 drCount: 0,
//                 urCount: 0,
//                 drSmallCount: 0,
//                 drBigCount: 0,
//                 urSmallCount: 0,
//                 urBigCount: 0,
//                 avgPercentage: 0,
//                 totalPercentage: 0,
//                 entries: []
//               });
//             }
            
//             const symbolData = symbolMap.get(symbol);
//             symbolData.count++;
//             symbolData.totalPercentage += percentageValue;
//             symbolData.avgPercentage = symbolData.totalPercentage / symbolData.count;
            
//             if (category === 'DR_SMALL') {
//               symbolData.drCount++;
//               symbolData.drSmallCount++;
//             } else if (category === 'DR_BIG') {
//               symbolData.drCount++;
//               symbolData.drBigCount++;
//             } else if (category === 'UR_SMALL') {
//               symbolData.urCount++;
//               symbolData.urSmallCount++;
//             } else if (category === 'UR_BIG') {
//               symbolData.urCount++;
//               symbolData.urBigCount++;
//             }
            
//             symbolData.entries.push(item);
//           });
//         }
//       });
      
//       let totalCount = 0;
//       const processedData = [];
      
//       for (const [symbol, data] of symbolMap.entries()) {
//         totalCount += data.count;
//         processedData.push({
//           name: symbol,
//           shortName: symbol.length > 20 ? symbol.substring(0, 18) + '...' : symbol,
//           signals: data.count,
//           drCount: data.drCount,
//           urCount: data.urCount,
//           drSmallCount: data.drSmallCount,
//           drBigCount: data.drBigCount,
//           urSmallCount: data.urSmallCount,
//           urBigCount: data.urBigCount,
//           avgPercentage: data.avgPercentage.toFixed(2),
//           successRate: ((data.drCount / data.count) * 100).toFixed(1),
//           entries: data.entries
//         });
//       }
      
//       processedData.sort((a, b) => b.signals - a.signals);
      
//       if (isMountedRef.current) {
//         setAllData(processedData);
//         setTotalSignals(totalCount);
//         setLastUpdated(new Date());
//         setTimeout(() => {
//           if (isMountedRef.current) {
//             updateChartDataWithCurrentSettings();
//           }
//         }, 0);
//       }
//     } catch (err) {
//       console.error("API Error:", err);
//     }
//   }, [token, updateChartDataWithCurrentSettings]);

//   const fetchDataInitial = async () => {
//     if (!token) {
//       setLoading(false);
//       setTimeout(() => navigate('/login'), 2000);
//       return;
//     }

//     try {
//       const response = await axios.get(
//         "https://api.algocontroller.com/admin_app/getting_admin_analysis",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       const rawData = response.data?.data || [];
      
//       const filteredData = [];
//       rawData.forEach(insItem => {
//         if (insItem.data && Array.isArray(insItem.data)) {
//           const filteredTypesData = insItem.data.filter(item => 
//             item.type === 'second' || item.type === 'third'
//           );
//           if (filteredTypesData.length > 0) {
//             filteredData.push({
//               ...insItem,
//               data: filteredTypesData
//             });
//           }
//         }
//       });
      
//       const symbolMap = new Map();
      
//       filteredData.forEach(insItem => {
//         if (insItem.data && Array.isArray(insItem.data)) {
//           insItem.data.forEach(item => {
//             const percentageValue = parseFloat(item.percentage);
//             if (percentageValue === 0) return;
            
//             const symbol = item.symbol;
//             const category = item.cat;
            
//             if (!symbolMap.has(symbol)) {
//               symbolMap.set(symbol, {
//                 symbol: symbol,
//                 count: 0,
//                 drCount: 0,
//                 urCount: 0,
//                 drSmallCount: 0,
//                 drBigCount: 0,
//                 urSmallCount: 0,
//                 urBigCount: 0,
//                 avgPercentage: 0,
//                 totalPercentage: 0,
//                 entries: []
//               });
//             }
            
//             const symbolData = symbolMap.get(symbol);
//             symbolData.count++;
//             symbolData.totalPercentage += percentageValue;
//             symbolData.avgPercentage = symbolData.totalPercentage / symbolData.count;
            
//             if (category === 'DR_SMALL') {
//               symbolData.drCount++;
//               symbolData.drSmallCount++;
//             } else if (category === 'DR_BIG') {
//               symbolData.drCount++;
//               symbolData.drBigCount++;
//             } else if (category === 'UR_SMALL') {
//               symbolData.urCount++;
//               symbolData.urSmallCount++;
//             } else if (category === 'UR_BIG') {
//               symbolData.urCount++;
//               symbolData.urBigCount++;
//             }
            
//             symbolData.entries.push(item);
//           });
//         }
//       });
      
//       let totalCount = 0;
//       const processedData = [];
      
//       for (const [symbol, data] of symbolMap.entries()) {
//         totalCount += data.count;
//         processedData.push({
//           name: symbol,
//           shortName: symbol.length > 20 ? symbol.substring(0, 18) + '...' : symbol,
//           signals: data.count,
//           drCount: data.drCount,
//           urCount: data.urCount,
//           drSmallCount: data.drSmallCount,
//           drBigCount: data.drBigCount,
//           urSmallCount: data.urSmallCount,
//           urBigCount: data.urBigCount,
//           avgPercentage: data.avgPercentage.toFixed(2),
//           successRate: ((data.drCount / data.count) * 100).toFixed(1),
//           entries: data.entries
//         });
//       }
      
//       processedData.sort((a, b) => b.signals - a.signals);
//       setAllData(processedData);
//       setTotalSignals(totalCount);
//       setLastUpdated(new Date());
//       setLoading(false);
      
//       setTimeout(() => {
//         if (isMountedRef.current) {
//           updateChartDataWithCurrentSettings();
//         }
//       }, 0);
//     } catch (err) {
//       console.error("API Error:", err);
//       setLoading(false);
//     }
//   };

//   const handleTopCountChange = (count) => {
//     setTopCount(count);
//     setTimeout(() => {
//       if (isMountedRef.current) {
//         updateChartDataWithCurrentSettings();
//       }
//     }, 0);
//   };

//   const handleSortChange = (sort) => {
//     setSortBy(sort);
//     setTimeout(() => {
//       if (isMountedRef.current) {
//         updateChartDataWithCurrentSettings();
//       }
//     }, 0);
//   };

//   const handleRefresh = () => {
//     fetchDataInitial();
//   };

//   const handleDownloadCSV = () => {
//     if (chartData.length === 0) {
//       toast.warning("No data to download!");
//       return;
//     }
    
//     const headers = ["Symbol", "Signals", "DR_SMALL", "DR_BIG", "UR_SMALL", "UR_BIG", "Total DR", "Total UR", "Success Rate %"];
//     const rows = chartData.map(item => [
//       item.name,
//       item.signals,
//       item.drSmallCount,
//       item.drBigCount,
//       item.urSmallCount,
//       item.urBigCount,
//       item.drCount,
//       item.urCount,
//       item.successRate
//     ]);
    
//     const csvContent = [headers, ...rows]
//       .map(row => row.join(","))
//       .join("\n");
    
//     const blob = new Blob([csvContent], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `signal-analysis-${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//     toast.success("CSV downloaded!");
//   };

//   const toggleFullscreen = () => {
//     if (!isFullscreen) {
//       const elem = chartContainerRef.current;
//       if (elem.requestFullscreen) {
//         elem.requestFullscreen();
//       }
//     } else {
//       if (document.exitFullscreen) {
//         document.exitFullscreen();
//       }
//     }
//     setIsFullscreen(!isFullscreen);
//   };

//   // ✅ Copy to clipboard function
//   const copyToClipboard = async (text, label) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       toast.success(`${label} copied!`, {
//         position: "top-right",
//         autoClose: 1000,
//         style: { fontSize: "12px", padding: "6px 12px" }
//       });
//     } catch (err) {
//       const textarea = document.createElement("textarea");
//       textarea.value = text;
//       document.body.appendChild(textarea);
//       textarea.select();
//       document.execCommand("copy");
//       document.body.removeChild(textarea);
//       toast.info(`${label} copied!`);
//     }
//   };

//   // Handle bar click
//   const handleBarClick = useCallback((entry, index) => {
//     if (!isMountedRef.current) return;
    
//     let symbol = null;
    
//     if (entry && entry.name) {
//       symbol = entry.name;
//     } else if (entry && entry.payload && entry.payload.name) {
//       symbol = entry.payload.name;
//     } else if (entry && entry.symbol) {
//       symbol = entry.symbol;
//     }
    
//     if (symbol) {
//       copyToClipboard(symbol, symbol);
//     }
//   }, []);

//   // Auto-refresh
//   useEffect(() => {
//     isMountedRef.current = true;
    
//     if (!token) {
//       setLoading(false);
//       setTimeout(() => navigate('/login'), 2000);
//       return;
//     }
    
//     fetchDataInitial();
    
//     intervalRef.current = setInterval(() => {
//       if (isMountedRef.current && token) {
//         fetchDataSilent();
//       }
//     }, 5000);
    
//     return () => {
//       isMountedRef.current = false;
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//     };
//   }, [token]);

//   useEffect(() => {
//     const handleFullscreenChange = () => {
//       setIsFullscreen(!!document.fullscreenElement);
//     };
    
//     document.addEventListener('fullscreenchange', handleFullscreenChange);
//     return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
//   }, []);

//   const formatCurrentTime = () => {
//     return currentTime.toLocaleTimeString('en-US', { 
//       hour: '2-digit', 
//       minute: '2-digit', 
//       second: '2-digit' 
//     });
//   };

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0].payload;
//       return (
//         <div className="custom-chart-tooltip">
//           <div className="tooltip-header">
//             <span className="tooltip-symbol">{data.name}</span>
//             <span className={`tooltip-badge ${data.drCount > data.urCount ? 'badge-dr' : 'badge-ur'}`}>
//               {data.drCount > data.urCount ? 'DR Dominant' : 'UR Dominant'}
//             </span>
//           </div>
//           <div className="tooltip-stats">
//             <div className="stat-item">
//               <span>📊 Total Signals:</span>
//               <strong>{data.signals}</strong>
//             </div>
//             <div className="stat-item">
//               <span>🟢 DR_SMALL:</span>
//               <strong style={{ color: '#10b981' }}>{data.drSmallCount}</strong>
//             </div>
//             <div className="stat-item">
//               <span>🌟 DR_BIG:</span>
//               <strong style={{ color: '#059669' }}>{data.drBigCount}</strong>
//             </div>
//             <div className="stat-item">
//               <span>🔴 UR_SMALL:</span>
//               <strong style={{ color: '#f87171' }}>{data.urSmallCount}</strong>
//             </div>
//             <div className="stat-item">
//               <span>💀 UR_BIG:</span>
//               <strong style={{ color: '#dc2626' }}>{data.urBigCount}</strong>
//             </div>
//             <div className="stat-item">
//               <span>📈 Success Rate:</span>
//               <strong>{data.successRate}%</strong>
//             </div>
//             <div className="stat-item">
//               <span>⭐ Avg Change:</span>
//               <strong>{data.avgPercentage}%</strong>
//             </div>
//           </div>
//           <div className="tooltip-footer">
//             ✨ Click on bar to copy symbol
//           </div>
//         </div>
//       );
//     }
//     return null;
//   };

//   // Calculate stats for display
//   const activeSymbolsCount = chartData.length;
//   const totalFilteredSignals = chartData.reduce((sum, item) => sum + item.signals, 0);

//   if (loading) {
//     return (
//       <div className="chart-loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading chart data...</p>
//       </div>
//     );
//   }

//   if (chartData.length === 0 && allData.length > 0) {
//     return (
//       <div className="chart-empty-container">
//         <div className="empty-icon">📊</div>
//         <p>No symbols with sufficient data (minimum 2 signals required)</p>
//         <p className="empty-subtitle">Symbols with only 1 signal are not shown in chart</p>
//         <button onClick={handleRefresh} className="refresh-empty-btn">
//           🔄 Refresh
//         </button>
//       </div>
//     );
//   }

//   if (chartData.length === 0) {
//     return (
//       <div className="chart-empty-container">
//         <div className="empty-icon">📊</div>
//         <p>No data available for chart</p>
//         <button onClick={handleRefresh} className="refresh-empty-btn">
//           🔄 Refresh
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="simple-bar-chart-container" ref={chartContainerRef}>
//       <ToastContainer 
//         position="top-right"
//         autoClose={1200}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss={false}
//         draggable={false}
//         pauseOnHover={false}
//         limit={3}
//       />
      
//       <div className="chart-header">
//         <div className="header-left">
//           <h3>📊 Signal Frequency Analysis</h3>
//           <div className="stats-badge">
//             <span className="stat">🎯 Total: {totalSignals}</span>
//             <span className="stat">📈 Active: {activeSymbolsCount}</span>
//             <span className="stat">⚡ Filtered: {totalFilteredSignals}</span>
//             <span className="stat time">🕐 Live: {formatCurrentTime()}</span>
//           </div>
//         </div>
//         <div className="header-right">
//           <div className="filter-group">
//             <label>Show Top:</label>
//             <select value={topCount} onChange={(e) => handleTopCountChange(Number(e.target.value))}>
//               <option value={60}>60</option>
//               <option value={120}>120</option>
//               <option value={260}>260</option>
//               <option value={320}>320</option>
//             </select>
//           </div>
//           <div className="filter-group">
//             <label>Sort By:</label>
//             <select value={sortBy} onChange={(e) => handleSortChange(e.target.value)}>
//               <option value="signals">📊 Total Signals</option>
//               <option value="name">🔤 Symbol Name</option>
//               <option value="dr">🟢 Total DR</option>
//               <option value="ur">🔴 Total UR</option>
//             </select>
//           </div>
//           <button onClick={handleRefresh} className="action-btn" title="Refresh">
//             <FiRefreshCcw size={14} />
//           </button>
//           <button onClick={handleDownloadCSV} className="action-btn" title="Download CSV">
//             <FiDownload size={14} />
//           </button>
//           <button onClick={toggleFullscreen} className="action-btn" title="Fullscreen">
//             {isFullscreen ? <FiMinimize2 size={14} /> : <FiMaximize2 size={14} />}
//           </button>
//         </div>
//       </div>

//       <ResponsiveContainer width="100%" height={500}>
//         <BarChart
//           data={chartData}
//           margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
//         >
//           <defs>
//             <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
//               <stop offset="0%" stopColor="#6366f1" stopOpacity={0.95}/>
//               <stop offset="50%" stopColor="#8b5cf6" stopOpacity={0.85}/>
//               <stop offset="100%" stopColor="#a78bfa" stopOpacity={0.75}/>
//             </linearGradient>
//           </defs>
//           <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
//           <XAxis 
//             dataKey="shortName" 
//             angle={-45} 
//             textAnchor="end" 
//             height={80} 
//             tick={{ fontSize: 10, fill: '#64748b', cursor: 'pointer' }}
//             interval={0}
//           />
//           <YAxis 
//             label={{ value: 'Number of Signals', angle: -90, position: 'insideLeft', style: { fontSize: 11, fill: '#64748b' } }}
//             tick={{ fontSize: 11 }}
//           />
//           <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(99, 102, 241, 0.08)' }} />
//           <Legend 
//             wrapperStyle={{ fontSize: 11, paddingTop: 15, cursor: 'pointer' }}
//             payload={[
//               { value: 'Total Signals (≥2 signals only)', type: 'rect', color: '#6366f1' },
//             ]}
//           />
//           <Bar 
//             dataKey="signals" 
//             name="Total Signals" 
//             fill="url(#barGradient)" 
//             radius={[8, 8, 0, 0]} 
//             barSize={35}
//             cursor="pointer"
//           >
//             {chartData.map((entry, index) => (
//               <Cell 
//                 key={`cell-${index}`} 
//                 fill={`url(#barGradient)`}
//                 style={{ cursor: 'pointer' }}
//                 onClick={() => handleBarClick(entry, index)}
//               />
//             ))}
//           </Bar>
//         </BarChart>
//       </ResponsiveContainer>

//       <div className="chart-footer">
//         <span>🔴 Showing symbols with minimum 2 signals only</span>
//         <span>💡 Click on any bar to copy symbol name</span>
//         <span>📊 Hover for detailed analysis</span>
//         <span>🔄 Auto-refreshes silently every 5 seconds</span>
//       </div>
//     </div>
//   );
// };

// export default SimpleBarChart;





import React, { useState, useEffect, useRef, useCallback } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import axios from "axios";
import { useAuth } from '../../context/auth';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FiRefreshCcw, FiDownload, FiMaximize2, FiMinimize2 } from 'react-icons/fi';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import '../cssStyle/SimpleBarChart.css';

const SimpleBarChart = () => {
  const [showChart, setShowChart] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalSignals, setTotalSignals] = useState(0);
  const [topCount, setTopCount] = useState(60);
  const [sortBy, setSortBy] = useState("signals");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  
  // Refs
  const topCountRef = useRef(30); 
  const sortByRef = useRef("signals");
  const allDataRef = useRef([]);
  const totalSignalsRef = useRef(0);
  const chartContainerRef = useRef(null);
  const intervalRef = useRef(null);
  const clockIntervalRef = useRef(null);
  const isMountedRef = useRef(true);
  
  const { getAdminAuthToken } = useAuth();
  const navigate = useNavigate();
  const token = getAdminAuthToken();

  // Update refs
  useEffect(() => {
    topCountRef.current = topCount;
  }, [topCount]);

  useEffect(() => {
    sortByRef.current = sortBy;
  }, [sortBy]);

  useEffect(() => {
    allDataRef.current = allData;
  }, [allData]);

  useEffect(() => {
    totalSignalsRef.current = totalSignals;
  }, [totalSignals]);

  // Real-time clock
  useEffect(() => {
    clockIntervalRef.current = setInterval(() => {
      if (isMountedRef.current) {
        setCurrentTime(new Date());
      }
    }, 1000);
    
    return () => {
      if (clockIntervalRef.current) {
        clearInterval(clockIntervalRef.current);
      }
    };
  }, []);

  const updateChartDataWithCurrentSettings = useCallback(() => {
    const currentAllData = allDataRef.current;
    const currentTopCount = topCountRef.current;
    const currentSortBy = sortByRef.current;
    const currentTotalSignals = totalSignalsRef.current;
    
    if (!currentAllData || currentAllData.length === 0) return;
    
    // Filter out symbols with only 1 signal
    let filteredData = currentAllData.filter(item => item.signals > 1);
    
    if (filteredData.length === 0) {
      setChartData([]);
      return;
    }
    
    let sortedData = [...filteredData];
    
    if (currentSortBy === "signals") {
      sortedData.sort((a, b) => b.signals - a.signals);
    } else if (currentSortBy === "name") {
      sortedData.sort((a, b) => a.name.localeCompare(b.name));
    } else if (currentSortBy === "dr") {
      sortedData.sort((a, b) => b.drCount - a.drCount);
    } else if (currentSortBy === "ur") {
      sortedData.sort((a, b) => b.urCount - a.urCount);
    }
    
    const topData = sortedData.slice(0, currentTopCount);
    const maxSignals = topData[0]?.signals || 1;
    
    const finalData = topData.map(item => ({
      ...item,
      percentage: ((item.signals / currentTotalSignals) * 100).toFixed(1),
      barWidthPercentage: (item.signals / maxSignals) * 100
    }));
    
    if (isMountedRef.current) {
      setChartData(finalData);
    }
  }, []);

  const fetchDataSilent = useCallback(async () => {
    if (!token || !isMountedRef.current) return;

    try {
      const response = await axios.get(
        "https://api.algocontroller.com/admin_app/getting_admin_analysis",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const rawData = response.data?.data || [];
      
      const filteredData = [];
      rawData.forEach(insItem => {
        if (insItem.data && Array.isArray(insItem.data)) {
          const filteredTypesData = insItem.data.filter(item => 
            item.type === 'second' || item.type === 'third'
          );
          if (filteredTypesData.length > 0) {
            filteredData.push({
              ...insItem,
              data: filteredTypesData
            });
          }
        }
      });
      
      const symbolMap = new Map();
      
      filteredData.forEach(insItem => {
        if (insItem.data && Array.isArray(insItem.data)) {
          insItem.data.forEach(item => {
            const percentageValue = parseFloat(item.percentage);
            if (percentageValue === 0) return;
            
            const symbol = item.symbol;
            const category = item.cat;
            
            if (!symbolMap.has(symbol)) {
              symbolMap.set(symbol, {
                symbol: symbol,
                count: 0,
                drCount: 0,
                urCount: 0,
                drSmallCount: 0,
                drBigCount: 0,
                urSmallCount: 0,
                urBigCount: 0,
                avgPercentage: 0,
                totalPercentage: 0,
                entries: []
              });
            }
            
            const symbolData = symbolMap.get(symbol);
            symbolData.count++;
            symbolData.totalPercentage += percentageValue;
            symbolData.avgPercentage = symbolData.totalPercentage / symbolData.count;
            
            if (category === 'DR_SMALL') {
              symbolData.drCount++;
              symbolData.drSmallCount++;
            } else if (category === 'DR_BIG') {
              symbolData.drCount++;
              symbolData.drBigCount++;
            } else if (category === 'UR_SMALL') {
              symbolData.urCount++;
              symbolData.urSmallCount++;
            } else if (category === 'UR_BIG') {
              symbolData.urCount++;
              symbolData.urBigCount++;
            }
            
            symbolData.entries.push(item);
          });
        }
      });
      
      let totalCount = 0;
      const processedData = [];
      
      for (const [symbol, data] of symbolMap.entries()) {
        totalCount += data.count;
        processedData.push({
          name: symbol,
          shortName: symbol.length > 20 ? symbol.substring(0, 18) + '...' : symbol,
          signals: data.count,
          drCount: data.drCount,
          urCount: data.urCount,
          drSmallCount: data.drSmallCount,
          drBigCount: data.drBigCount,
          urSmallCount: data.urSmallCount,
          urBigCount: data.urBigCount,
          avgPercentage: data.avgPercentage.toFixed(2),
          successRate: ((data.drCount / data.count) * 100).toFixed(1),
          entries: data.entries
        });
      }
      
      processedData.sort((a, b) => b.signals - a.signals);
      
      if (isMountedRef.current) {
        setAllData(processedData);
        setTotalSignals(totalCount);
        setLastUpdated(new Date());
        setTimeout(() => {
          if (isMountedRef.current) {
            updateChartDataWithCurrentSettings();
          }
        }, 0);
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  }, [token, updateChartDataWithCurrentSettings]);

  const fetchDataInitial = async () => {
    if (!token) {
      setLoading(false);
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    try {
      const response = await axios.get(
        "https://api.algocontroller.com/admin_app/getting_admin_analysis",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const rawData = response.data?.data || [];
      
      const filteredData = [];
      rawData.forEach(insItem => {
        if (insItem.data && Array.isArray(insItem.data)) {
          const filteredTypesData = insItem.data.filter(item => 
            item.type === 'second' || item.type === 'third'
          );
          if (filteredTypesData.length > 0) {
            filteredData.push({
              ...insItem,
              data: filteredTypesData
            });
          }
        }
      });
      
      const symbolMap = new Map();
      
      filteredData.forEach(insItem => {
        if (insItem.data && Array.isArray(insItem.data)) {
          insItem.data.forEach(item => {
            const percentageValue = parseFloat(item.percentage);
            if (percentageValue === 0) return;
            
            const symbol = item.symbol;
            const category = item.cat;
            
            if (!symbolMap.has(symbol)) {
              symbolMap.set(symbol, {
                symbol: symbol,
                count: 0,
                drCount: 0,
                urCount: 0,
                drSmallCount: 0,
                drBigCount: 0,
                urSmallCount: 0,
                urBigCount: 0,
                avgPercentage: 0,
                totalPercentage: 0,
                entries: []
              });
            }
            
            const symbolData = symbolMap.get(symbol);
            symbolData.count++;
            symbolData.totalPercentage += percentageValue;
            symbolData.avgPercentage = symbolData.totalPercentage / symbolData.count;
            
            if (category === 'DR_SMALL') {
              symbolData.drCount++;
              symbolData.drSmallCount++;
            } else if (category === 'DR_BIG') {
              symbolData.drCount++;
              symbolData.drBigCount++;
            } else if (category === 'UR_SMALL') {
              symbolData.urCount++;
              symbolData.urSmallCount++;
            } else if (category === 'UR_BIG') {
              symbolData.urCount++;
              symbolData.urBigCount++;
            }
            
            symbolData.entries.push(item);
          });
        }
      });
      
      let totalCount = 0;
      const processedData = [];
      
      for (const [symbol, data] of symbolMap.entries()) {
        totalCount += data.count;
        processedData.push({
          name: symbol,
          shortName: symbol.length > 20 ? symbol.substring(0, 18) + '...' : symbol,
          signals: data.count,
          drCount: data.drCount,
          urCount: data.urCount,
          drSmallCount: data.drSmallCount,
          drBigCount: data.drBigCount,
          urSmallCount: data.urSmallCount,
          urBigCount: data.urBigCount,
          avgPercentage: data.avgPercentage.toFixed(2),
          successRate: ((data.drCount / data.count) * 100).toFixed(1),
          entries: data.entries
        });
      }
      
      processedData.sort((a, b) => b.signals - a.signals);
      setAllData(processedData);
      setTotalSignals(totalCount);
      setLastUpdated(new Date());
      setLoading(false);
      
      setTimeout(() => {
        if (isMountedRef.current) {
          updateChartDataWithCurrentSettings();
        }
      }, 0);
    } catch (err) {
      console.error("API Error:", err);
      setLoading(false);
    }
  };

  const toggleChart = () => {
    setShowChart(!showChart);
  };

  const handleTopCountChange = (count) => {
    setTopCount(count);
    setTimeout(() => {
      if (isMountedRef.current) {
        updateChartDataWithCurrentSettings();
      }
    }, 0);
  };

  const handleSortChange = (sort) => {
    setSortBy(sort);
    setTimeout(() => {
      if (isMountedRef.current) {
        updateChartDataWithCurrentSettings();
      }
    }, 0);
  };

  const handleRefresh = () => {
    fetchDataInitial();
  };

  const handleDownloadCSV = () => {
    if (chartData.length === 0) {
      toast.warning("No data to download!");
      return;
    }
    
    const headers = ["Symbol", "Signals", "DR_SMALL", "DR_BIG", "UR_SMALL", "UR_BIG", "Total DR", "Total UR", "Success Rate %"];
    const rows = chartData.map(item => [
      item.name,
      item.signals,
      item.drSmallCount,
      item.drBigCount,
      item.urSmallCount,
      item.urBigCount,
      item.drCount,
      item.urCount,
      item.successRate
    ]);
    
    const csvContent = [headers, ...rows]
      .map(row => row.join(","))
      .join("\n");
    
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `signal-analysis-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("CSV downloaded!");
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      const elem = chartContainerRef.current;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
    setIsFullscreen(!isFullscreen);
  };

  // Copy to clipboard function
  const copyToClipboard = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} copied!`, {
        position: "top-right",
        autoClose: 1000,
        style: { fontSize: "12px", padding: "6px 12px" }
      });
    } catch (err) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      toast.info(`${label} copied!`);
    }
  };

  // Handle bar click
  const handleBarClick = useCallback((entry, index) => {
    if (!isMountedRef.current) return;
    
    let symbol = null;
    
    if (entry && entry.name) {
      symbol = entry.name;
    } else if (entry && entry.payload && entry.payload.name) {
      symbol = entry.payload.name;
    } else if (entry && entry.symbol) {
      symbol = entry.symbol;
    }
    
    if (symbol) {
      copyToClipboard(symbol, symbol);
    }
  }, []);

  // Auto-refresh
  useEffect(() => {
    isMountedRef.current = true;
    
    if (!token) {
      setLoading(false);
      setTimeout(() => navigate('/login'), 2000);
      return;
    }
    
    fetchDataInitial();
    
    intervalRef.current = setInterval(() => {
      if (isMountedRef.current && token) {
        fetchDataSilent();
      }
    }, 5000);
    
    return () => {
      isMountedRef.current = false;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [token]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const formatCurrentTime = () => {
    return currentTime.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    });
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="custom-chart-tooltip">
          <div className="tooltip-header">
            <span className="tooltip-symbol">{data.name}</span>
            <span className={`tooltip-badge ${data.drCount > data.urCount ? 'badge-dr' : 'badge-ur'}`}>
              {data.drCount > data.urCount ? 'DR Dominant' : 'UR Dominant'}
            </span>
          </div>
          <div className="tooltip-stats">
            <div className="stat-item">
              <span>📊 Total Signals:</span>
              <strong>{data.signals}</strong>
            </div>
            <div className="stat-item">
              <span>🟢 DR_SMALL:</span>
              <strong style={{ color: '#10b981' }}>{data.drSmallCount}</strong>
            </div>
            <div className="stat-item">
              <span>🌟 DR_BIG:</span>
              <strong style={{ color: '#059669' }}>{data.drBigCount}</strong>
            </div>
            <div className="stat-item">
              <span>🔴 UR_SMALL:</span>
              <strong style={{ color: '#f87171' }}>{data.urSmallCount}</strong>
            </div>
            <div className="stat-item">
              <span>💀 UR_BIG:</span>
              <strong style={{ color: '#dc2626' }}>{data.urBigCount}</strong>
            </div>
            <div className="stat-item">
              <span>📈 Success Rate:</span>
              <strong>{data.successRate}%</strong>
            </div>
            <div className="stat-item">
              <span>⭐ Avg Change:</span>
              <strong>{data.avgPercentage}%</strong>
            </div>
          </div>
          <div className="tooltip-footer">
            ✨ Click on bar to copy symbol
          </div>
        </div>
      );
    }
    return null;
  };

  // Calculate stats for display
  const activeSymbolsCount = chartData.length;
  const totalFilteredSignals = chartData.reduce((sum, item) => sum + item.signals, 0);

  if (loading) {
    return (
      <div className="chart-loading-container">
        <div className="loading-spinner"></div>
        <p>Loading chart data...</p>
      </div>
    );
  }

  if (chartData.length === 0 && allData.length > 0) {
    return (
      <div className="chart-empty-container">
        <div className="empty-icon">📊</div>
        <p>No symbols with sufficient data (minimum 2 signals required)</p>
        <p className="empty-subtitle">Symbols with only 1 signal are not shown in chart</p>
        <button onClick={handleRefresh} className="refresh-empty-btn">
          🔄 Refresh
        </button>
      </div>
    );
  }

  if (chartData.length === 0) {
    return (
      <div className="chart-empty-container">
        <div className="empty-icon">📊</div>
        <p>No data available for chart</p>
        <button onClick={handleRefresh} className="refresh-empty-btn">
          🔄 Refresh
        </button>
      </div>
    );
  }

  return (
    <div className="simple-bar-chart-container" ref={chartContainerRef}>
      <ToastContainer 
        position="top-right"
        autoClose={1200}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        limit={3}
      />
      
      {/* Header with Toggle */}
      <div className="chart-header" onClick={toggleChart} style={{ cursor: 'pointer' }}>
        <div className="header-left">
          <h3>📊 Signal Frequency Analysis</h3>
          <div className="stats-badge">
            <span className="stat">🎯 Total: {totalSignals}</span>
            <span className="stat">📈 Active: {activeSymbolsCount}</span>
            <span className="stat">⚡ Filtered: {totalFilteredSignals}</span>
            <span className="stat time">🕐 Live: {formatCurrentTime()}</span>
          </div>
        </div>
        <div className="header-right">
          <div className="filter-group" onClick={(e) => e.stopPropagation()}>
            <label>Show Top:</label>
            <select value={topCount} onChange={(e) => handleTopCountChange(Number(e.target.value))}>
              <option value={60}>60</option>
              <option value={120}>120</option>
              <option value={260}>260</option>
              <option value={320}>320</option>
            </select>
          </div>
          <div className="filter-group" onClick={(e) => e.stopPropagation()}>
            <label>Sort By:</label>
            <select value={sortBy} onChange={(e) => handleSortChange(e.target.value)}>
              <option value="signals">📊 Total Signals</option>
              <option value="name">🔤 Symbol Name</option>
              <option value="dr">🟢 Total DR</option>
              <option value="ur">🔴 Total UR</option>
            </select>
          </div>
          <button onClick={(e) => { e.stopPropagation(); handleRefresh(); }} className="action-btn" title="Refresh">
            <FiRefreshCcw size={14} />
          </button>
          <button onClick={(e) => { e.stopPropagation(); handleDownloadCSV(); }} className="action-btn" title="Download CSV">
            <FiDownload size={14} />
          </button>
          <button onClick={(e) => { e.stopPropagation(); toggleFullscreen(); }} className="action-btn" title="Fullscreen">
            {isFullscreen ? <FiMinimize2 size={14} /> : <FiMaximize2 size={14} />}
          </button>
          <span className="chart-toggle-icon">
            {showChart ? <IoIosArrowUp size={18} /> : <IoIosArrowDown size={18} />}
          </span>
        </div>
      </div>

      {/* Chart Content - Toggle */}
      {showChart && (
        <>
          <ResponsiveContainer width="100%" height={500}>
            <BarChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
            >
              <defs>
                <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#6366f1" stopOpacity={0.95}/>
                  <stop offset="50%" stopColor="#8b5cf6" stopOpacity={0.85}/>
                  <stop offset="100%" stopColor="#a78bfa" stopOpacity={0.75}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
              <XAxis 
                dataKey="shortName" 
                angle={-45} 
                textAnchor="end" 
                height={80} 
                tick={{ fontSize: 10, fill: '#64748b', cursor: 'pointer' }}
                interval={0}
              />
              <YAxis 
                label={{ value: 'Number of Signals', angle: -90, position: 'insideLeft', style: { fontSize: 11, fill: '#64748b' } }}
                tick={{ fontSize: 11 }}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(99, 102, 241, 0.08)' }} />
              <Legend 
                wrapperStyle={{ fontSize: 11, paddingTop: 15, cursor: 'pointer' }}
                payload={[
                  { value: 'Total Signals (≥2 signals only)', type: 'rect', color: '#6366f1' },
                ]}
              />
              <Bar 
                dataKey="signals" 
                name="Total Signals" 
                fill="url(#barGradient)" 
                radius={[8, 8, 0, 0]} 
                barSize={35}
                cursor="pointer"
              >
                {chartData.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={`url(#barGradient)`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleBarClick(entry, index)}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>

          <div className="chart-footer">
            <span>🔴 Showing symbols with minimum 2 signals only</span>
            <span>💡 Click on any bar to copy symbol name</span>
            <span>📊 Hover for detailed analysis</span>
            <span>🔄 Auto-refreshes silently every 5 seconds</span>
          </div>
        </>
      )}
    </div>
  );
};

export default SimpleBarChart; 